module.exports = __webpack_public_path__ + "img/buddy_antenna-03.96665e6c.svg";